(() => {
  if (window.__cdUpsellLoaded) return;
  window.__cdUpsellLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const GAP = 8;

  function stepOf(track) {
    const first = track.children[0];
    return (first ? first.offsetWidth : track.clientWidth) + GAP;
  }

  function updateNav(track) {
    const box = track.closest('.cd-upsell');
    if (!box) return;
    const total = track.children.length;
    let index = Math.round(track.scrollLeft / stepOf(track));
    if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) index = total - 1;
    index = Math.min(total - 1, Math.max(0, index));
    const count = box.querySelector('[data-cd-count]');
    const prev = box.querySelector('[data-cd-prev]');
    const next = box.querySelector('[data-cd-next]');
    if (count) count.textContent = (index + 1) + '/' + total;
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index >= total - 1;
  }

  document.addEventListener('scroll', (event) => {
    const el = event.target;
    if (el && el.classList && el.classList.contains('cd-upsell__track')) updateNav(el);
  }, true);

  async function refreshDrawer() {
    const res = await fetch(root + '?sections=cart-drawer');
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('.drawer__inner');
    const current = document.querySelector('cart-drawer .drawer__inner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    const host = document.querySelector('cart-drawer');
    if (host) host.classList.remove('is-empty');
  }

  document.addEventListener('click', async (event) => {
    const arrow = event.target.closest('[data-cd-prev], [data-cd-next]');
    if (arrow) {
      const track = arrow.closest('.cd-upsell').querySelector('[data-cd-track]');
      const dir = arrow.hasAttribute('data-cd-next') ? 1 : -1;
      track.scrollBy({ left: dir * stepOf(track), behavior: 'smooth' });
      return;
    }

    const btn = event.target.closest('[data-cd-add]');
    if (!btn) return;
    event.preventDefault();

    const card = btn.closest('.cd-upsell__card');
    const select = card.querySelector('[data-cd-variant]');
    const variantId = parseInt(select ? select.value : btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      await refreshDrawer();
    } catch (e) {
      btn.disabled = false;
      btn.textContent = label;
    }
  });
})();